/* eslint-disable no-constant-condition */
/* eslint-disable no-await-in-loop */
import axios from 'axios';

import { estimateApiCallMock } from '../../mock-data/mockApiCalls';
import { ESTIMATE_API_URL } from '../constants/urls';
import { MAX_ESTIMATE_RETRIES, MAX_VANTAGE_RETRIES } from '../constants/api-constants';
import { timestampToIsoFormat } from './helper';
import { publishApiToNewRelic } from './newRelic';

// MAKE SURE THIS IS ALWAYS SET TO FALSE BEFORE MERGE
const useMock = { estimate: false };

// There's an issue with Vantage sometimes failing for fun right now (Sept. 15, 2022)
// Once we have an actual fix (or a stronger bandaid), we should remove/repurpose this method.
export function isVantageError(error) {
  return error.response && error.response.status === 500 && error.response.data === 'Error retrieving Vantage token';
}

export async function retryCallOnVantageError(call, maxRetries = MAX_VANTAGE_RETRIES) {
  let retries = 0;
  while (true) {
    try {
      return await call();
    } catch (error) {
      if (isVantageError(error) && retries < maxRetries) {
        retries += 1;
      } else { throw error; }
    }
  }
}

export async function getEstimate({
  host,
  pickupTime,
  returnTime,
  storeId,
  rentalCategory,
  rentalSubCategory
}) {
  const endpoint = `${host}${ESTIMATE_API_URL}`;
  const body = {
    pickupTime: timestampToIsoFormat(pickupTime),
    returnTime: timestampToIsoFormat(returnTime),
    store: storeId,
    tools: [{
      categoryCode: rentalCategory,
      subCategoryCode: rentalSubCategory
    }]
  };
  let retries = 0;

  const callEstimate = async () => {
    const response = useMock.estimate
      ? await estimateApiCallMock(2000, retries)
      : await axios.post(endpoint, body);

    publishApiToNewRelic(
      {
        action: 'success',
        output: {
          component: 'rental-estimate',
          apiName: 'RENTAL-RATE-CALCULATOR',
          baseEndpoint: ESTIMATE_API_URL,
          endpoint,
          retries,
          ...body,
          data: response.data
        }
      }
    );
    return response.data;
  };

  while (true) {
    try {
      return await retryCallOnVantageError(callEstimate);
    } catch (error) {
      publishApiToNewRelic(
        {
          action: 'error',
          output: {
            component: 'rental-estimate',
            apiName: 'RENTAL-RATE-CALCULATOR',
            baseEndpoint: ESTIMATE_API_URL,
            endpoint,
            retries,
            ...body,
            error
          }
        }
      );
      if (retries >= MAX_ESTIMATE_RETRIES) {
        throw new Error('Unexpected Error');
      }
      retries += 1;
    }
  }
}
